import { createApp } from 'vue'
import App from './App.vue'

// UnoCSS reset
import '@unocss/reset/tailwind.css'
import 'virtual:uno.css'

// reset style sheet
import '@/styles/reset.scss'
// CSS common style sheet
import '@/styles/common.scss'
// layout base
import '@/styles/layout.scss'
// iconfont css
import '@/assets/iconfont/iconfont.scss'
// font css
import '@/assets/fonts/font.scss'

// element plus
import ElementPlus from 'element-plus'
// element icons
import * as Icons from '@element-plus/icons-vue'
// element css
import 'element-plus/dist/index.css'
// element dark(内置暗黑模式)
import 'element-plus/theme-chalk/dark/css-vars.css'
// custom element dark(自定义暗黑模式)
import '@/styles/theme/element-dark.scss'

// custom directives
import directives from '@/directives/index'
// vue Router
import router from '@/routers'
// vue i18n
import I18n from '@/i18n'
// pinia store
import pinia from '@/store/index'
// echarts
import '@/utils/echarts-register'
// echarts css / scss variables
import '@/styles/echarts-theme.scss'

// charts component library
import ChartsPlugin from '@/components/echarts/export'
import { usePermissionsStore } from '@/store/modules/user/permissions'
import { initLanguage } from '@/utils/lang'

// 全局禁用右键
document.addEventListener('contextmenu', (event) => {
  event.preventDefault()
})

const app = createApp(App)

app.use(pinia)

const permissionStore = usePermissionsStore()

// 刷新页面立刻恢复动态路由
permissionStore.initRoutesOnRefresh(router)

// 初始化语言（同步 vue-i18n / cache / html lang / dayjs）
initLanguage()

// 注册 element Icons 组件
Object.keys(Icons).forEach((key) => {
  app.component(key, Icons[key as keyof typeof Icons])
})

// 注册 charts 插件
app.use(ChartsPlugin)

app.use(router).use(I18n).use(directives).use(ElementPlus).mount('#app')
